<template>
  <DefaultSection class="section is-medium howto">
    <div class="container">
      <div class="has-text-centered">
        <img
          alt="Logo"
          class="logo"
          src="~/assets/svgs/lessmess-logo-inverted.svg?url"
          data-not-lazy
        />
      </div>
      <h2
        class="title is-size-medium has-text-centered has-text-weight-bold mb-6"
      >
        {{ title }}
      </h2>
      <div class="list">
        <div
          v-for="(step, key) in howtos"
          :key="key"
          class="item"
          v-html="step"
        />
      </div>
      <div class="has-text-centered mt-6">
        <VuepalLink
          v-if="link && link.url"
          :to="link.url.path"
          class="button is-lessmess-desk large has-text-weight-bold is-size-6"
        >
          {{ link.title }}
        </VuepalLink>
      </div>
    </div>
  </DefaultSection>
</template>

<script setup lang="ts">
import type { ParagraphHowToFragment } from '#graphql-operations'

defineProps<ParagraphHowToFragment>()
defineBlokkli({
  bundle: 'how_to',
})
</script>

<style scoped lang="scss">
.howto {
  background-color: $background-gray;

  .logo {
    height: 44px;
    margin-top: toRem(20);
    margin-bottom: toRem(60);

    @include tablet {
      height: 62px;
    }
  }

  .list {
    margin: 40px 0 0 0;
    text-align: center;

    @include tablet {
      text-align: left;
      column-count: 2;
      gap: 140px;
      margin: 80px 80px 0 80px;
    }

    .item {
      font-weight: $weight-semibold;
      margin-bottom: 2rem;
      ::v-deep(p) {
        margin-bottom: 0.3rem;
        > strong {
          font-weight: $weight-bold;
        }
      }
    }
  }
}
</style>
